import { render, staticRenderFns } from "./SpaceTable.vue?vue&type=template&id=6a480b6e&scoped=true&lang=pug&"
import script from "./SpaceTable.vue?vue&type=script&lang=js&"
export * from "./SpaceTable.vue?vue&type=script&lang=js&"
import style0 from "./SpaceTable.vue?vue&type=style&index=0&id=6a480b6e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a480b6e",
  null
  
)

export default component.exports